export enum LineItemType {
    Donation = 1,
    Item = 3,
    Ticket = 4
}
